import React, { forwardRef } from "react";
import DatePicker from "react-datepicker";
import "react-datepicker/dist/react-datepicker.css";
import { classNames, convertToDefEventPara } from "../../shared/utility";
import { CalendarIcon } from "@heroicons/react/24/outline";
import { Calendar } from "primereact/calendar";

export default function DatePickerInput(props) {
  const {
    classes,
    label,
    name,
    onChange,
    value,
    labelOn,
    error,
    explanation,
    labelDivClass,
    labelClass,
    dateFormat,
    parentClass,
    ...other
  } = props;

  const ExampleCustomInput = forwardRef(
    ({ value, onClick, className, placeholder }, ref) => (
      <button
        type="button"
        className={classNames(
          className
            ? className
            : "border border-gray-300 rounded-md mt-1 block w-full shadow-sm py-2 px-3 text-left focus:outline-none sm:text-sm",
          "flex items-center justify-between"
        )}
        onClick={onClick}
        ref={ref}
      >
        <span className={value ? "" : "text-gray-400"}>
          {value ? value : placeholder ? placeholder : "Select date"}
        </span>
        <CalendarIcon className="h-5 w-5 text-gray-400" />
      </button>
    )
  );

  return (
    <div className={parentClass}>
      {labelOn ? (
        <div className="mb-1">
          <label
            htmlFor={name}
            className={classNames(
              labelClass ? labelClass : "text-sm",
              "block font-medium text-gray-900"
            )}
          >
            {label}
          </label>
        </div>
      ) : null}
      <div>
        <Calendar
          value={value ? new Date(value) : null}
          onChange={(e) =>
            onChange(convertToDefEventPara(name, e.target.value))
          }
          dateFormat="M dd, yy"
          className="date-picker block w-full focus:outline-none sm:text-sm sm:max-w-xs md:max-w-full"
          {...other}
        />
        {error ? <p className="font-medium text-red-500">{error}</p> : null}
      </div>
    </div>
  );
}
